// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: "AIzaSyCXrQlvMLhLS-m0iClVw8hkTOSzMY1SVWw",
  authDomain: "saludmental-1fb2a.firebaseapp.com",
  projectId: "saludmental-1fb2a",
  storageBucket: "saludmental-1fb2a.appspot.com",
  messagingSenderId: "204794236124",
  appId: "1:204794236124:web:f37ede1e05e59bd9283819",
  measurementId: "G-PL4QNHNLR2"
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
